/**
 * @file 博士会入口
 * @author  rentao（v-rentao@baidu.com）
 */
 import 'react-app-polyfill/ie9';
 import 'react-app-polyfill/stable';
 import 'location-origin';
 import React from 'react';
 import ReactDOM from 'react-dom';
 
 import Assocation from './Assocation';
 
 import './style.less';
 
 
 
 ReactDOM.render(<Assocation/>, document.getElementById('root'));
 
 
 